module.exports = __webpack_public_path__ + "img/newproject1.0fb3fb64.jpg";